import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-modal" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Carregando...")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "loadingModal",
    "can-close": false
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}